import React from 'react';

/**
 * Component to inject dynamic JSON-LD for AI SEO crawlers
 * to understand the specific color being analyzed.
 */
const StructuredData = ({ color, mood }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    "name": `Brand Color Analysis: ${color}`,
    "description": mood.description,
    "keywords": mood.tags.join(', '),
    "mainEntity": {
      "@type": "Thing",
      "name": color,
      "description": `A ${mood.title} shade used in ${mood.industries.join(', ')} industries.`
    }
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default StructuredData;